module.exports = __webpack_public_path__ + "static/middleBackground-bc8223074f47599310e77729f944c288.png";